import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import { Breadcrumbs, Button, Input,
  Container, CssBaseline, Grid, Typography, CircularProgress} from '@material-ui/core';
import Header from './../../compoments/Header'
import MaterialTable from 'material-table'
import api from './../../services/axios'
import { Redirect } from 'react-router'
import Icon from '@material-ui/core/Icon';
import Papa from 'papaparse'
import AlertDialog from './../../compoments/AlertDialog'
import MaterialTableComponent from './../../compoments/MaterialTableComponent'

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    }
  },
  input: {
    display: 'none',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function ClientesImport({ history }) {

  const role = 'clientes';
  const roleName = 'Clientes';

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [redirect, setRedirect] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [token, setToken] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [fileName, setFileName] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(false);
  const [theInputKey, setTheInputKey] = React.useState('');

  useEffect(() => {
    setToken(localStorage.getItem('token'));
  }, [])

  const clearCsv = () => { 
    setData([]);
    setTheInputKey(Math.random().toString(36));
  };

  const onFileChange = event => { 
    const csvfile = event.target.files[0];
    setSelectedFile(csvfile);     
    const updateData = (result) => {
      setData(result.data);
    }
    const importCSV = (csvfile) => {
      Papa.parse(csvfile, {
        complete: updateData,
        header: true,
        fastMode: true,
        escapeChar: '"',
        quoteChar: '"',
        transform: (d) => { 
          return d.replace('"', '').replace('"', '');
        }, 
      });
    };
    importCSV(csvfile);
  };

  const onFileUpload = async () => { 
    const formData = new FormData(); 
    formData.append( 
      "csv", 
      selectedFile, 
      selectedFile.name 
    ); 
    try { 
      setLoading(true);
      const data = await api.post('/v1/clients/import', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      });
      setAlertTitle('Enviado!');
      setMessage('Os dados foram importados com sucesso!')
      setLoading(false);
    } catch(error) {
      const em = error.response && error.response.data && error.response.data.errors
                  && error.response.data.errors[0] && error.response.data.errors[0].message 
                  || 'Erro inesperado';
      setAlertTitle('Erro');
      setMessage(em);
      setLoading(false);
    }
  }; 

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect}/>}
      <CssBaseline />
      {/* TOPO E MENU DRAWER*/}
      <Header titleHeader={roleName} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${role}`}>
                  {roleName}
                </Link>
                <Typography color="textPrimary">Importação</Typography>
              </Breadcrumbs>
            </Grid>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <form encType="multipart/form-data" method="POST" action="/v1/clients/import">
                <Input type="file" 
                  key={theInputKey || '' }
                  name="csv"
                  onChange={onFileChange}
                  id="contained-button-file"
                  className={classes.input}
                />
                <label htmlFor="contained-button-file" style={{display: data.length > 0 ? 'none' : 'block'}}>
                  <Button variant="contained" component="span"
                    startIcon={<CloudUploadIcon />}
                  >
                    Selecionar arquivo CSV
                  </Button>
                </label>
                <Input
                  type="hidden"
                  name="token"
                  value={token}
                  style={{marginRight: 20}}
                />
                { data.length > 0 && 
                  <>
                    <Button
                      disabled={loading}
                      type="reset"
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      startIcon={<DeleteIcon />}
                      onClick={clearCsv}
                      style={{marginRight: 20}}
                    >
                      Cancelar
                    </Button>
                    <Button  
                      disabled={loading}
                      variant="contained" 
                      color="primary" 
                      onClick={onFileUpload}
                      startIcon={loading ? <CircularProgress size={10} /> : <Icon>send</Icon> } >
                      {loading ? 'Enviando...' : 'Enviar' }
                    </Button>
                  </>
                }
              </form>
            </Grid>
            <Grid item xs={12}>
            { data.length > 0 && 
                <MaterialTableComponent
                  columns={[
                    { title: 'Nome', field: 'NOME' },
                    { title: 'Código', field: 'CODIGO' },
                    { title: 'Cpf', field: 'CPF' }
                  ]}
                  data={data}
                  title=""
                  actions={[
                    // {
                    //   icon: 'edit',
                    //   tooltip: 'Editar',
                    //   onClick: (event, rowData) => {
                    //     setRedirect(`/clientes/update/${rowData.id}`)
                    //   }
                    // },
                    // rowData => ({
                    //   icon: 'delete',
                    //   tooltip: 'Deletar',
                    //   onClick: (event, rowData) => deleteUser(rowData.id),
                    //   disabled: false
                    // }),
                    // {
                    //   icon: 'add',
                    //   tooltip: 'Criar '+roleName,
                    //   isFreeAction: true,
                    //   onClick: (event) => setRedirect(`/${role}/create`) 
                    // },
                    // {
                    //   icon: 'open_in_browser',
                    //   tooltip: 'Importar CSV',
                    //   isFreeAction: true,
                    //   onClick: (event) => setRedirect(`/${role}/create`) 
                    // }
                  ]}
                  options={{
                    actionsColumnIndex: -1
                  }}
                />
              }
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => { 
              setMessage(false); 
              history.push('/' + role)
            }}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}